import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';
import UserLoggedInUser from './UserLoggedInUser';
import UserSiderProjectList from './UserSiderProjectList';
import {fetchUserUnreadCounts} from '../api/services';
import {initSocket} from '../socket';
import {showNotification} from '../utils/chatNotificationHelper';
const UserSidebar = ({setActivePage, onMenuSelect}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState(0);
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const loggedInUserId = localStorage.getItem('id');

  const token = localStorage.getItem('token');
  const socket = initSocket(token);

  useEffect(() => {
    const path = location.pathname.replace('/', '') || '/';
    setActivePage(path);
  }, [location, setActivePage]);

  const getIcon = (path, icon, activeIcon) => {
    return location.pathname === path ? activeIcon : icon;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!user && !socket) return;

    fetchUserUnreadCounts(loggedInUserId)
      .then((result) => {
        if (Array.isArray(result)) {
          const total = result.reduce(
            (sum, item) => sum + (item.count || 0),
            0
          );
          setUnreadCounts(total);
        } else {
          setUnreadCounts(0);
        }
      })
      .catch((err) => {
        console.error('fetchUnreadCounts error', err);
      });

    // join socket
    socket.emit('join', loggedInUserId);

    const handleUnreadCounts = (counts) => {
      const total = Array.isArray(counts)
        ? counts.reduce((sum, item) => sum + (item.count || 0), 0)
        : 0;
      // 🔔 Show toast + sound when count increases
      if (total > unreadCounts) {
        showNotification('New message received!');
      }
      setUnreadCounts(total);
    };
    socket.on('unreadCounts', handleUnreadCounts);

    return () => {
      socket.off('unreadCounts', handleUnreadCounts);
    };
  }, [user, token, socket, , unreadCounts, loggedInUserId]);

  useEffect(() => {
    if (loggedInUserId) {
      fetchUserUnreadCounts(loggedInUserId).then((data) => {
        setUnreadCounts(data?.unreadCounts);
      });

      socket.on('unreadCounts', (data) => {
        setUnreadCounts(data?.unreadCounts);
      });
    }
  }, [loggedInUserId]);

  return (
    <div
      className={`bg-gradient-to-b from-white via-gray-50 to-white ${
        isMobile ? 'h-[92%]' : 'h-full'
      } w-[250px] fixed font-customFont border-r-2 border-[#D5D7DA]`}
    >
      <div className="flex items-center justify-start ms-3 mt-3">
        <img src="/logo.png" className="w-[40px]" alt="Logo" />
        <p
          className="text-black font-bold text-2xl"
          style={{fontFamily: 'Noto Serif, sans-serif'}}
        >
          Expense
        </p>
      </div>

      <div
        className={`mt-2 ms-3 pb-2 space-y-1 border-b-2 border-[#D5D7DA] ${
          isMobile ? 'me-3' : 'me-3'
        } `}
      >
        <div
          className={`flex items-center p-2 rounded-lg cursor-pointer transition-all duration-300 ${
            location.pathname === '/user/dashboard'
              ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25'
              : 'text-gray-600 hover:bg-blue-50 hover:text-blue-600'
          }`}
          onClick={() => {
            navigate('/user/dashboard');
            if (onMenuSelect) onMenuSelect();
          }}
        >
          <div
            className={`w-7 h-7 rounded-lg flex items-center justify-center mr-3 transition-all duration-300 ${
              location.pathname === '/user/dashboard'
                ? 'bg-white/20'
                : 'bg-gray-100 group-hover:bg-blue-100'
            }`}
          >
            <i className="fas fa-tachometer-alt text-sm"></i>
          </div>
          <span className="flex-1">Dashboard</span>
          {location.pathname === '/user/dashboard' && (
            <div className="w-2 h-2 bg-white rounded-full"></div>
          )}
        </div>
        <div
          className={`flex items-center p-2 rounded-lg cursor-pointer transition-all duration-300 ${
            location.pathname === '/user/expenseList'
              ? 'bg-gradient-to-r from-teal-500 to-teal-600 text-white shadow-lg shadow-teal-500/25'
              : 'text-gray-600 hover:bg-teal-50 hover:text-teal-600'
          }`}
          onClick={() => {
            navigate('/user/expenseList');
            if (onMenuSelect) onMenuSelect();
          }}
        >
          <div
            className={`w-7 h-7 rounded-lg flex items-center justify-center mr-3 transition-all duration-300 ${
              location.pathname === '/user/expenseList'
                ? 'bg-white/20'
                : 'bg-gray-100 group-hover:bg-teal-100'
            }`}
          >
            <i className="fas fa-credit-card text-sm"></i>
          </div>
          <span className="flex-1">Transactions</span>
          {location.pathname === '/user/expenseList' && (
            <div className="w-2 h-2 bg-white rounded-full"></div>
          )}
        </div>
        <div
          className={`flex items-center p-2 rounded-lg cursor-pointer transition-all duration-300 ${
            location.pathname === '/user/chat'
              ? 'bg-gradient-to-r from-indigo-500 to-indigo-600 text-white shadow-lg shadow-indigo-500/25'
              : 'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600'
          }`}
          onClick={() => {
            navigate('/user/chat');
            if (onMenuSelect) onMenuSelect();
          }}
        >
          <div
            className={`w-7 h-7 rounded-lg flex items-center justify-center mr-3 transition-all duration-300 ${
              location.pathname === '/user/chat'
                ? 'bg-white/20'
                : 'bg-gray-100 group-hover:bg-indigo-100'
            }`}
          >
            <i className="fas fa-comment-dots text-sm"></i>
          </div>
          <span className="flex-1">Chat</span>
          {unreadCounts > 0 && (
            <span className="text-xs bg-blue-600 text-white rounded-full w-5 h-5 pt-0.5 flex items-center justify-center">
              {unreadCounts}
            </span>
          )}
          {location.pathname === '/chats' && !unreadCounts && (
            <div className="w-2 h-2 bg-white rounded-full"></div>
          )}
        </div>
      </div>

      <UserSiderProjectList onMenuSelect={onMenuSelect} />

      <div className="absolute bottom-0 left-0 w-full p-2 pl-3 flex items-center cursor-pointer text-gray-700">
        <UserLoggedInUser onMenuSelect={onMenuSelect} />
      </div>
    </div>
  );
};

UserSidebar.propTypes = {
  setActivePage: PropTypes.func.isRequired,
};

export default UserSidebar;
